import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { bankSchema } from "../helpers/yupSchema";
import Alert from 'react-bootstrap/Alert';
import ApiService from "../services/ApiService";


const BankForm = ({ token }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue
  } = useForm({
    resolver: yupResolver(bankSchema),
  });

  const usStatesAndTerritories = [
    { code: "AL", name: "Alabama" },
    { code: "AK", name: "Alaska" },
    { code: "AZ", name: "Arizona" },
    { code: "AR", name: "Arkansas" },
    { code: "CA", name: "California" },
    { code: "CO", name: "Colorado" },
    { code: "CT", name: "Connecticut" },
    { code: "DE", name: "Delaware" },
    { code: "FL", name: "Florida" },
    { code: "GA", name: "Georgia" },
    { code: "HI", name: "Hawaii" },
    { code: "ID", name: "Idaho" },
    { code: "IL", name: "Illinois" },
    { code: "IN", name: "Indiana" },
    { code: "IA", name: "Iowa" },
    { code: "KS", name: "Kansas" },
    { code: "KY", name: "Kentucky" },
    { code: "LA", name: "Louisiana" },
    { code: "ME", name: "Maine" },
    { code: "MD", name: "Maryland" },
    { code: "MA", name: "Massachusetts" },
    { code: "MI", name: "Michigan" },
    { code: "MN", name: "Minnesota" },
    { code: "MS", name: "Mississippi" },
    { code: "MO", name: "Missouri" },
    { code: "MT", name: "Montana" },
    { code: "NE", name: "Nebraska" },
    { code: "NV", name: "Nevada" },
    { code: "NH", name: "New Hampshire" },
    { code: "NJ", name: "New Jersey" },
    { code: "NM", name: "New Mexico" },
    { code: "NY", name: "New York" },
    { code: "NC", name: "North Carolina" },
    { code: "ND", name: "North Dakota" },
    { code: "OH", name: "Ohio" },
    { code: "OK", name: "Oklahoma" },
    { code: "OR", name: "Oregon" },
    { code: "PA", name: "Pennsylvania" },
    { code: "RI", name: "Rhode Island" },
    { code: "SC", name: "South Carolina" },
    { code: "SD", name: "South Dakota" },
    { code: "TN", name: "Tennessee" },
    { code: "TX", name: "Texas" },
    { code: "UT", name: "Utah" },
    { code: "VT", name: "Vermont" },
    { code: "VA", name: "Virginia" },
    { code: "WA", name: "Washington" },
    { code: "WV", name: "West Virginia" },
    { code: "WI", name: "Wisconsin" },
    { code: "WY", name: "Wyoming" },
    { code: "AS", name: "American Samoa" },
    { code: "DC", name: "District of Columbia" },
    { code: "FM", name: "Federated States of Micronesia" },
    { code: "GU", name: "Guam" },
    { code: "MH", name: "Marshall Islands" },
    { code: "MP", name: "Northern Mariana Islands" },
    { code: "PW", name: "Palau" },
    { code: "PR", name: "Puerto Rico" },
    { code: "VI", name: "Virgin Islands" },
  ];

  const [alert, setAlert] = useState({
    show: false,
    variant: "secondary",
    text: "",
  });
  const [loading, setLoading] = useState(false);
  const [outlets, setOutlets] = useState([]);

  const handleBankSubmit = async (data) => {
    try {
      setLoading(true);
      data.token = token;
      let allpayments = await ApiService.getPayments(data);      
      for (const item of allpayments) {
        await ApiService.removePayment({
          token: token,
          id: item.PaymentMethodID,
          outlet: item.Outlet,
        });
        console.log("Removed Payment with id: " + item.PaymentMethodID);
      }
      
      await ApiService.saveCheckPayment(data);
      setLoading(false);
      setAlert({
        show: true,
        variant: 'success',
        text: 'Thank You! E-Check details updated successfully.',
      })
      reset({
        routingnumber: '',
        accountnumber: '',
        firstname: '',
        lastname: '',
        accounttype: '',
        state: '',
        zipcode: ''
      })
    } catch (error) {
      console.log(error);
      setLoading(false);
      setAlert({
        show: true,
        variant: 'warning',
        text: `Unfortunately, we were unable to update your payment details. A patient coordinator will reach out to you shortly to collect payment details.`,
      })
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    // Allow only numeric input
    const numericValue = value.replace(/\D/g, '');
    e.target.value = numericValue;
  };

  const fetchOutlets = async () => {
    try {
      let outlets = await ApiService.getOutlets();
      setOutlets(outlets);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchOutlets();
  }, [])

    useEffect(() => {
      if(outlets.length > 0){
        setValue('outlet', outlets[0].id)
      }
    },[outlets, setValue])

  return (
    <div className="card-form mt-4">
      {
        alert.show
        ?
            <div className="mb-2">
                <Alert variant={alert.variant} onClose={() => setAlert({show: false})} dismissible className="mb-0">
                    <p className="mb-0">{alert.text}</p>
                    {/* <div className="" dangerouslySetInnerHTML={{__html: alert.text}}></div> */}
                </Alert>
            </div>
        :
            null
      }
      <form onSubmit={handleSubmit(handleBankSubmit)}>
        <div className="mb-3">
          <Controller
            control={control}
            name="outlet"
            render={({ field }) => (
              <select {...field} className={`form-select ${errors.outlet?.message ? `error` : ``}`}>
                {outlets.map((outlet) => (
                  <option key={outlet.id} value={outlet.id}>
                    {outlet.name}
                  </option>
                ))}
              </select>
            )}
          />
        </div>
        <div className="mb-3">
          <Controller
            control={control}
            name="routingnumber"
            render={({ field }) => (
              <input
                {...field}
                className={`form-control ${
                  errors.routingnumber?.message ? `error` : ``
                }`}
                onChange={(e) => {
                  handleInputChange(e);
                  field.onChange(e);
                }}
                type="tel"
                id="routingnumber"
                placeholder="Routing Number"
              />
            )}
          />
        </div>
        <div className="mb-3">
          <Controller
            control={control}
            name="accountnumber"
            render={({ field }) => (
              <input
                {...field}
                type="tel"
                className={`form-control ${
                  errors.accountnumber?.message ? `error` : ``
                }`} 
                onChange={(e) => {
                  handleInputChange(e);
                  field.onChange(e);
                }}               
                id="accountnumber"
                placeholder="Account Number"
              />
            )}
          />
        </div>
        <div className="d-flex align-items-center mb-3 gap-2 w-100">
          <Controller
            control={control}
            name="firstname"
            render={({ field }) => (
              <input
                {...field}
                type="text"
                className={`form-control ${
                  errors.firstname?.message ? `error` : ``
                }`}    
                id="firstname"
                placeholder="First Name"
              />
            )}
          />
          <Controller
            control={control}
            name="lastname"
            render={({ field }) => (
              <input
                {...field}
                type="text"
                className={`form-control ${
                  errors.lastname?.message ? `error` : ``
                }`}
                id="lastname"
                placeholder="Last Name"
              />
            )}
          />
        </div>
        <div className="mb-3">
          <Controller
            control={control}
            name="accounttype"
            render={({ field }) => (
              <select
                {...field}
                name="accounttype"
                id="accounttype"
                className={`form-select ${
                  errors.accounttype?.message ? `error` : ``
                }`}
              >
                <option value="">Select Account Type</option>
                <option value="Checking">Checking</option>
                <option value="Savings">Savings</option>
                <option value="Business">Business</option>
              </select>
            )}
          />
        </div>

        <div className="mb-3">
          <Controller
            control={control}
            name="state"
            render={({ field }) => (
              <select {...field} name="state" id="state" className={`form-select ${
                      errors.state?.message ? `error` : ``
                    }`}>
                <option value="">Select State</option>
                {usStatesAndTerritories.map((s) => (
                  <option key={s.code} value={s.code}>{s.name}</option>
                ))}
              </select>
            )}/>
        </div>
        <div className="mb-3">
          <Controller
            control={control}
            name="zipcode"
            render={({ field }) => (
              <input
                {...field}
                type="tel"
                className={`form-control ${
                  errors.zipcode?.message ? `error` : ``
                }`}
                onChange={(e) => {
                  handleInputChange(e);
                  field.onChange(e);
                }}
                id="zipcode"
                maxLength={5}
                placeholder="Zip Code"
              />
            )}
          />
        </div>
        <div className="d-flex align-items-center gap-2">
        <button
            disabled={loading}
            className="btn btn-custom-primary"
            type="submit"
          >
            <span className="">Submit</span>
            {loading ? (
              <span
                className="ms-2 spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            ) : null}
          </button>
          <button className="btn btn-custom-primary" disabled={loading} onClick={reset} type="reset">
            Reset
          </button>
        </div>
      </form>
    </div>
  );
};

export default BankForm;
